import { useMemo as o } from "react";
import { useDebounce as m } from "@partoohub/hooks";
import { removeEmptyValues as p } from "@partoohub/utils";
import { useInfiniteQuery as f } from "react-query";
import { useBusinessModalContext as l } from "../BusinessModalContext.js";
import { useBusinessesQueryParams as d } from "./queryParams/business/useBusinessesQueryParams.js";
const g = "businesses", F = (a = {}) => {
  const {
    apiClient: i
  } = l(), u = d(), r = m(u, 300), t = o(() => p(r), [JSON.stringify(r)]), s = f([g, JSON.stringify(t)], ({
    pageParam: e = 1
  }) => i.business.searchBusinesses({
    ...t,
    page: e
  }), {
    getNextPageParam: (e) => e.page < e.max_page ? e.page + 1 : void 0,
    refetchOnReconnect: !1,
    refetchOnWindowFocus: !1,
    ...a
  }), c = o(() => {
    const e = s?.data?.pages?.flatMap((n) => n.businesses) ?? [];
    return Array.from(new Map(e.map((n) => [n.id, n])).values());
  }, [s?.data?.pages]);
  return {
    query: s,
    businesses: c,
    count: s.data?.pages?.[0]?.count
  };
};
export {
  g as BUSINESSES,
  F as useBusinesses
};
